function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "white",
  fillOpacity: 0.15
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.20781 6.11495C7.92976 6.29448 7.66524 6.49318 7.41613 6.70917L11.9999 11.2927L16.5836 6.70923C16.3345 6.49323 16.0699 6.29453 15.7919 6.115L11.9999 9.90684L8.20781 6.11495ZM13.8578 5.24918C14.2091 5.34566 14.5495 5.46885 14.8764 5.61641L11.9999 8.49283L9.12328 5.61636C9.45025 5.4688 9.79059 5.34563 10.142 5.24915L11.9999 7.10697L13.8578 5.24918ZM17.2906 7.41623L12.7069 11.9997L17.2905 16.5831C17.5065 16.334 17.7052 16.0695 17.8848 15.7914L14.0928 11.9997L17.8848 8.20789C17.7053 7.92984 17.5066 7.66533 17.2906 7.41623ZM18.3834 9.12333L15.5069 11.9997L18.3834 14.876C18.5309 14.549 18.6541 14.2087 18.7506 13.8574L16.8929 11.9997L18.7506 10.142C18.6542 9.79062 18.531 9.45029 18.3834 9.12333ZM16.5835 17.2901L11.9999 12.7067L7.41624 17.2902C7.66536 17.5061 7.92988 17.7048 8.20794 17.8844L11.9999 14.0926L15.7918 17.8843C16.0698 17.7048 16.3343 17.5061 16.5835 17.2901ZM14.8763 18.3829L11.9999 15.5066L9.12339 18.3829C9.45037 18.5305 9.79071 18.6536 10.1421 18.7501L11.9999 16.8924L13.8576 18.7501C14.209 18.6536 14.5494 18.5304 14.8763 18.3829ZM6.70918 16.5831L11.2929 11.9997L6.70912 7.41615C6.49311 7.66525 6.29441 7.92975 6.11487 8.2078L9.90693 11.9997L6.11492 15.7915C6.29446 16.0696 6.49317 16.3341 6.70918 16.5831ZM5.61631 14.8761L8.49286 11.9997L5.61626 9.12322C5.46869 9.45018 5.34551 9.7905 5.24902 10.1419L7.10693 11.9997L5.24906 13.8575C5.34554 14.2088 5.46873 14.5492 5.61631 14.8761Z",
  fill: "white"
});
function SvgStacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacks);
export default __webpack_public_path__ + "static/media/stacks.d61fed12f5c2f806f02d4a12ae11f576.svg";
export { ForwardRef as ReactComponent };